var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37522 0.351085C8.81862 0.819198 8.81862 1.5796 8.37522 2.04885L3.96388 6.70486H18.8623C19.164 6.70486 19.4534 6.83141 19.6668 7.05666C19.8801 7.28191 20 7.58742 20 7.90597C20 8.22453 19.8801 8.53003 19.6668 8.75528C19.4534 8.98054 19.164 9.10708 18.8623 9.10708L3.80165 9.10594L8.37522 13.9344C8.48403 14.0451 8.57083 14.1777 8.63056 14.3243C8.69029 14.4709 8.72174 14.6286 8.72308 14.7882C8.72443 14.9478 8.69563 15.1061 8.63838 15.2538C8.58112 15.4015 8.49656 15.5357 8.38963 15.6485C8.2827 15.7613 8.15555 15.8505 8.0156 15.9108C7.87565 15.9712 7.72572 16.0015 7.57455 15.9999C7.42339 15.9984 7.27403 15.9651 7.1352 15.902C6.99637 15.8388 6.87085 15.7471 6.76598 15.6321L0.333362 8.84106C0.227676 8.72952 0.143838 8.59709 0.0866394 8.45134C0.0294403 8.30559 0 8.14937 0 7.9916C0 7.83384 0.0294403 7.67762 0.0866394 7.53187C0.143838 7.38611 0.227676 7.25369 0.333362 7.14215L6.76598 0.351085C7.21047 -0.117028 7.93073 -0.117028 8.37522 0.351085Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBack);
export default __webpack_public_path__ + "static/media/blackBack.9517039e299b84d8ba932bd3d7b851d4.svg";
export { ForwardRef as ReactComponent };